
import React from 'react';
import { CheckCircle, Mail } from 'lucide-react';

const ResetEmailSent = () => {
  return (
    <div className="flex flex-col items-center justify-center py-4 space-y-4">
      <div className="w-16 h-16 bg-green-100 dark:bg-green-900/20 rounded-full flex items-center justify-center">
        <CheckCircle className="w-8 h-8 text-green-600 dark:text-green-400" />
      </div>
      
      <h3 className="text-xl font-semibold">Password Reset Email Sent!</h3>
      
      <div className="text-center text-muted-foreground">
        <p className="mb-2">
          We've sent password reset instructions to your email address.
        </p>
        <p className="flex items-center justify-center gap-1">
          <Mail className="w-4 h-4" /> Check your inbox and spam folder
        </p>
      </div>
      
      <div className="border rounded-lg p-4 bg-muted/50 text-sm w-full mt-4">
        <p className="font-semibold">Don't see the email?</p>
        <ul className="list-disc pl-5 mt-2 space-y-1">
          <li>Check your spam or junk folder</li>
          <li>Make sure you entered the correct email address</li>
          <li>Wait a few minutes for the email to arrive</li>
          <li>Try requesting another reset link later</li>
        </ul>
      </div>
    </div>
  );
};

export default ResetEmailSent;
